import { MENU_COLORS } from "@lhd/constants";
import styled from "styled-components";
import { DISPLAY_SIZES } from "@lhd/types";

export const Styles = styled.div<{
  text_scale?: "small" | "medium" | "large";
}>`
  --table-cell-padding: 2px;

  .table-div__header {
    color: #fff;

    .table-div__cell {
      background: #4e525b;
    }
  }

  &.editing {
    .table-div__row .table-div__cell {
      background: #f8f8f8ff;
      overflow-x: auto;
    }
  }

  .ant-form-item {
    margin: 0;
    width: 100%;
  }

  --field-control-height: var(--cell-height, 32px);

  .ant-input,
  .ant-picker,
  .ant-form-item-control-input {
    min-height: var(--cell-height);
  }

  .table-div__cell > div:first-child {
    width: 100%;
  }

  .table-div__row.row_new > .table-div__cell {
    animation: var(--animation-blink);
  }

  .table-div__row.selected {
    &:hover {
      .table-div__cell {
        background: rgb(228, 104, 106);
      }
    }
    .table-div__cell {
      background: #ff4d4f;
    }
  }
  .table-div__row.row_banned {
    &:hover {
      .table-div__cell {
        background: #d9dde5;
      }
    }
    .table-div__cell {
      background: #9ca3af;
    }
  }

  .table-div__row.row_new,
  .table-div__row.row_editing {
    position: sticky;
    z-index: 101;
    bottom: 0;
    top: var(--table-total-height-header-row);
    box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.18), 0 2px 12px rgba(0, 0, 0, 0.18);
    .table-div__cell {
      background: #ffffffff;
    }
  }
  .bg-blue {
    background-color: var(--active-color);
  }
  .bg-blue-light {
    background-color: var(--inactive-color);
  }
  .table-div-has-quick-view {
    height: 450px !important;
  }

  .tooltip-wrap,
  .tooltip-disabled-wrap {
    display: inline-block;
  }

  .tooltip-disabled-wrap {
    cursor: not-allowed;
  }

  .tooltip-disabled-wrap > * {
    pointer-events: none;
  }
  .cancel-btn {
    background-color: ${MENU_COLORS.DELETE_ALL} !important;
    color: ${MENU_COLORS.TEXT_WHITE} !important;
  }

  .table-div__cell_header:has(.column-action-header) {
    overflow: visible;

    .table-div__cell_header_inner,
    .table-div__col-drag {
      overflow: visible;
    }
  }

  .wrap-cell-rich_text {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    word-break: break-all;

    * {
      display: inline !important;
      margin: 0 !important;
      padding: 0 !important;
      background: transparent !important;
    }

    img {
      display: inline-block !important;
      max-height: 24px !important;
      width: auto !important;
      vertical-align: middle;
      margin-right: 4px !important;
    }
  }

  .sticky-buttons-header {
    position: sticky;
    top: 0;
    z-index: 1000;
    background-color: #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
  .vertical {
    position: fixed;
    width: stretch;
    .quickview-header_vertical {
      top: 13px;
    }
  }
  .btn-delete,
  .btn-delete-disable {
    min-width: ${({ text_scale }) =>
      text_scale?.includes(DISPLAY_SIZES.LARGE)
        ? "100px"
        : text_scale?.includes(DISPLAY_SIZES.MEDIUM)
        ? "86px"
        : "80px"} !important;
    width: ${({ text_scale }) =>
      text_scale?.includes(DISPLAY_SIZES.LARGE)
        ? "100px"
        : text_scale?.includes(DISPLAY_SIZES.MEDIUM)
        ? "86px"
        : "80px"} !important;
  }
`;
